import { canUseDOM } from 'exenv';

export default function matchMediaDesktop(minWidth = '40em') {
  if (canUseDOM) {
    return window.matchMedia(`(min-width: ${minWidth})`).matches;
  }
  return false;
}
